// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"ConversationHistory_sectionTitle__3cKKw","deleteButton":"ConversationHistory_deleteButton__2kYiv"};